/* eslint-disable no-console */
import axios from "axios";
import { clearIntervalAsync, setIntervalAsync } from "set-interval-async/dynamic";
import { CONF } from "./types/Config";
import { createWorker, workerInstance } from "./workers/keepalive.worker";
export const datasets = new Map();
const customNotifHandlers = new Map();
export let isSocketClosed = false;
//import order is important due to circular dependencies...project needs refactoring
import { subscribers } from "./SubscriptionHandler";
import { subscribersV2 } from "./SubscriptionHandlerV2";
const RTD_SUB_DETAILS = "rtd-subs-details";
const DATASET_MISMATCH_ERROR = "dataset mismatch";
const QUEUESTAT_DATASET = {
    datasetName: "wxcc.rtd.queuestats",
    type: "RealtimeDataset",
    data: {
        type: "SubscriptionResponse",
        datasetName: "wxcc.rtd.queuestats",
        datasetValues: [
            {
                key: "<queue-id-1>",
                operation: "UPSERT",
                data: {
                    queueId: "<queue-id-1>",
                    queueName: "<queue-name>",
                    channelType: "telephony",
                    queuedContactsCount: 24,
                    oldestContactParkedTime: 1620708963000,
                    totalQueuedContacts: 121,
                    totalContactsHandled: 98,
                    totalContactsAbandoned: 23,
                    totalQueueDuration: 32855,
                    totalRingingDuration: 6543,
                    totalContactWithinSla: 85,
                    maxQueueDuration: 637
                }
            },
            {
                key: "<queue-id-2>",
                operation: "UPSERT",
                data: {
                    queueId: "<queue-id-2>",
                    queueName: "<queue-name>",
                    channelType: "email",
                    queuedContactsCount: 24,
                    oldestContactParkedTime: 1620708963000,
                    totalQueuedContacts: 121,
                    totalContactsHandled: 98,
                    totalContactsAbandoned: 23,
                    totalQueueDuration: 32855,
                    totalRingingDuration: 6543,
                    totalContactWithinSla: 85,
                    maxQueueDuration: 637
                }
            }
        ]
    }
};
const NOTIFS_RESOLVE_DELAY = 1200;
const CONNECTIVITY_CHECK_INTERVAL = 1000;
export class LegacyWebSocketHandler {
    constructor() {
        this.keepAliveWorker = createWorker(workerInstance());
        this.postOnlineStatusCheck = (e) => {
            this.onlineStatus = e.detail;
            console.log(`[RTDWC] Received connection status from desktop | timestamp=${new Date()}, UTC=${new Date().toUTCString()} | ${e.detail}`);
            this.keepAliveWorker.postMessage({
                type: "onlineStatus",
                onlineStatus: this.onlineStatus
            });
        };
        console.log(`[RTDWC] WebSocketHandler initialized | timestamp=${new Date()}, UTC=${new Date().toUTCString()}`);
        this.isWelcomeReceived = false;
        this.startWelcomeTime = 0;
        this.endWelcomeTime = 0;
        this.shouldReconnect = true;
        this.httpHeaders = {};
        this.onlineStatus = undefined;
    }
    async init() {
        if (CONF.pingEvent) {
            window.removeEventListener(CONF.pingEvent, this.postOnlineStatusCheck);
            window.addEventListener(CONF.pingEvent, this.postOnlineStatusCheck);
        }
        await this.register();
        await this.connect();
    }
    onMessageHandler(event) {
        const { data } = event;
        if (data && typeof data === "string") {
            this.processMessage(data);
        }
        else {
            console.warn(`[RTDWC] Unexpected data in message handler ${data} | timestamp=${new Date()}, UTC=${new Date().toUTCString()}`);
        }
    }
    /**
     * Process incoming WebSocket messages with support for custom event handlers
     * @param rawData The raw message data from WebSocket
     */
    processMessage(rawData) {
        let realtimeData;
        try {
            realtimeData = JSON.parse(rawData);
        }
        catch (error) {
            console.error(`[RTDWC] Failed to parse WebSocket message as JSON | Error: ${error} | Raw data: ${rawData} | timestamp=${new Date()}, UTC=${new Date().toUTCString()}`);
            return;
        }
        const type = realtimeData.type;
        let messageHandled = false;
        if (type) {
            switch (type) {
                case "RealtimeDataset":
                    messageHandled = this.handleRealtimeDataset(realtimeData);
                    break;
                case "Welcome":
                    messageHandled = this.handleWelcomeMessage(rawData);
                    break;
                default:
                    messageHandled = this.handleCustomNotifications(realtimeData, type);
                    break;
            }
        }
        if (!messageHandled && !realtimeData.keepalive) {
            console.warn(`[RTDWC] Unhandled message type: ${type} | Data:`, realtimeData, `| timestamp=${new Date()}, UTC=${new Date().toUTCString()}`);
        }
    }
    /**
     * Handle RealtimeDataset messages (SubscriptionResponse and RealtimeFeed)
     */
    handleRealtimeDataset(realtimeData) {
        const subType = realtimeData.data ? realtimeData.data.type : {};
        const datasetName = realtimeData.data?.datasetName;
        const opt = datasets.get(datasetName);
        switch (subType) {
            case "SubscriptionResponse":
                return this.handleSubscriptionResponse(opt, realtimeData, datasetName);
            case "RealtimeFeed":
                return this.handleRealtimeFeed(opt, realtimeData, datasetName);
            default:
                console.warn(`[RTDWC] Unknown RealtimeDataset subType: ${subType} | timestamp=${new Date()}, UTC=${new Date().toUTCString()}`);
                return false;
        }
    }
    /**
     * Handle SubscriptionResponse messages
     */
    handleSubscriptionResponse(opt, realtimeData, datasetName) {
        if (opt) {
            opt.subscriptionCallback(null, realtimeData.data || QUEUESTAT_DATASET);
        }
        else {
            console.warn(`[RTDWC] No dataset handler found for: ${datasetName}`);
            opt?.subscriptionCallback(DATASET_MISMATCH_ERROR);
        }
        return true;
    }
    /**
     * Handle RealtimeFeed messages
     */
    handleRealtimeFeed(opt, realtimeData, datasetName) {
        if (opt) {
            opt.updateCallback(null, realtimeData.data);
        }
        else {
            console.warn(`[RTDWC] No dataset handler found for: ${datasetName}`);
            opt?.updateCallback(DATASET_MISMATCH_ERROR);
        }
        return true;
    }
    /**
     * Handle Welcome messages
     */
    handleWelcomeMessage(rawData) {
        window.dispatchEvent(new CustomEvent(RTD_SUB_DETAILS, {
            bubbles: true,
            composed: true,
            detail: rawData
        }));
        return true;
    }
    /**
     * Handle custom notification messages using registered handlers
     */
    handleCustomNotifications(realtimeData, type) {
        const customHandlers = customNotifHandlers.get(type);
        if (!customHandlers || customHandlers.length === 0) {
            return false;
        }
        console.log(`[RTDWC] Processing message type '${type}' with ${customHandlers.length} custom handler(s) | timestamp=${new Date()}, UTC=${new Date().toUTCString()}`);
        customHandlers.forEach((handler, index) => {
            try {
                handler(realtimeData, type);
            }
            catch (error) {
                console.error(`[RTDWC] Error in custom event handler ${index} for message type '${type}': ${error} | timestamp=${new Date()}, UTC=${new Date().toUTCString()}`);
            }
        });
        return true;
    }
    async checkOnlineStatus() {
        if (CONF.pingURL) {
            const METHOD_NAME = CONF.pingURL && CONF.pingURL.includes("localhost") ? "GET" : "HEAD";
            try {
                const online = await fetch(CONF.pingURL, {
                    method: METHOD_NAME,
                    headers: {
                        "cache-control": "no-cache, no-store, must-revalidate"
                    }
                });
                return online.status >= 200 && online.status < 300;
                // eslint-disable-next-line sonarjs/no-ignored-exceptions
            }
            catch {
                return false;
            }
        }
        else {
            return typeof this.onlineStatus === "undefined" ? navigator.onLine : this.onlineStatus;
        }
    }
    onSocketCloseSend() {
        console.info(`[RTDWC] event=socketConnectionRetry | Retry to reconnect is going to begin | timestamp=${new Date()}, UTC=${new Date().toUTCString()}`);
        const reconnectInterval = setIntervalAsync(async () => {
            console.info(`[RTDWC] event=socketConnectionRetry | Trying to reconnect to notifs socket | timestamp=${new Date()}, UTC=${new Date().toUTCString()}`);
            const onlineStatus = await this.checkOnlineStatus();
            if (onlineStatus) {
                this.init();
                clearIntervalAsync(reconnectInterval);
            }
            else {
                console.error(`[RTDWC] event=socketConnectionRetry | browser network not available | timestamp=${new Date()}, UTC=${new Date().toUTCString()}`);
            }
        }, CONNECTIVITY_CHECK_INTERVAL);
        setTimeout(() => {
            clearIntervalAsync(reconnectInterval);
        }, parseInt(CONF.lostConnectionRecoveryTimeout, 10));
    }
    listener(options) {
        datasets.set(options.datasetName, { ...options });
    }
    /**
     * Register a custom event handler for specific message types
     * @param messageType The message type to handle (e.g., "CustomEvent", "Notification")
     * @param handler The callback function to execute when this message type is received
     */
    registerCustomNotiftHandler(messageType, handler) {
        const handlers = customNotifHandlers.get(messageType) || [];
        handlers.push(handler);
        customNotifHandlers.set(messageType, handlers);
        console.log(`[RTDWC] Registered custom event handler for message type: ${messageType} | timestamp=${new Date()}, UTC=${new Date().toUTCString()}`);
    }
    /**
     * Unregister a custom event handler for a specific message type
     * @param messageType The message type to stop handling
     * @param handler The specific handler to remove (optional - if not provided, removes all handlers for this type)
     */
    unregisterCustomNotifHandler(messageType, handler) {
        if (!handler) {
            customNotifHandlers.delete(messageType);
            console.log(`[RTDWC] Removed all custom notif handlers for message type: ${messageType} | timestamp=${new Date()}, UTC=${new Date().toUTCString()}`);
            return;
        }
        const handlers = customNotifHandlers.get(messageType);
        if (!handlers) {
            return;
        }
        const updatedHandlers = handlers.filter((h) => h !== handler);
        if (updatedHandlers.length === 0) {
            customNotifHandlers.delete(messageType);
        }
        else {
            customNotifHandlers.set(messageType, updatedHandlers);
        }
        console.log(`[RTDWC] Removed specific custom notif handler for message type: ${messageType} | timestamp=${new Date()}, UTC=${new Date().toUTCString()}`);
    }
    /**
     * Get all registered custom notif handlers for debugging/inspection
     */
    getRegisteredNotifHandlers() {
        return new Map(customNotifHandlers);
    }
    async subscribe(datasetName, subscriberDataSet) {
        const token = CONF.accessToken;
        try {
            const res = await axios.post(CONF.rtdUrl ? `${CONF.rtdUrl}` : `${CONF.rtdHost}/subscribe`, {
                timestamp: new Date().getTime(),
                datasets: [datasetName],
                websocketSubscriptionId: this.subscriptionId
            }, {
                headers: { Authorization: `Bearer ${token}`, ...this.httpHeaders }
            });
            if (subscriberDataSet) {
                subscriberDataSet.isInProgress = false;
                subscriberDataSet.isError = false;
            }
            const { data } = res;
            return data;
        }
        catch (e) {
            console.error(`[RTDWC] Error while subscription | ${e} | timestamp=${new Date()}, UTC=${new Date().toUTCString()}`);
            if (subscriberDataSet) {
                subscriberDataSet.isInProgress = false;
                subscriberDataSet.isError = true;
            }
            datasets.get(datasetName).subscriptionCallback(e);
            throw e;
        }
    }
    unsubscribe(datasetName) {
        return axios.post(`${CONF.rtdHost}/unsubscribe`, {
            timestamp: new Date().getTime(),
            datasets: [datasetName],
            websocketSubscriptionId: this.subscriptionId
        }, {
            headers: { Authorization: `Bearer ${CONF.accessToken}`, ...this.httpHeaders }
        });
    }
    async register() {
        const token = CONF.accessToken;
        const httpHeaders = CONF.httpHeaders;
        this.httpHeaders = httpHeaders;
        const res = await axios.post(CONF.notifUrl ? `${CONF.notifUrl}` : `${CONF.notifHost}/register`, {
            force: true,
            isKeepAliveEnabled: true,
            clientType: CONF.clientType,
            allowMultiLogin: true
        }, {
            headers: { Authorization: `Bearer ${token}`, ...this.httpHeaders }
        });
        if (res && res.data) {
            this.webSocketUrl = res.data.webSocketUrl;
            this.subscriptionId = res.data.subscriptionId;
        }
        else {
            throw new Error("[RTDWC] registration failed");
        }
    }
    async connect() {
        this.socket = new WebSocket(this.webSocketUrl);
        return new Promise((resolve, reject) => {
            if (this.socket) {
                this.socket.onopen = () => {
                    isSocketClosed = false;
                    console.log(`[RTDWC] New Socket has created with subscription id:  ${this.subscriptionId} | timestamp=${new Date()}, UTC=${new Date().toUTCString()}`);
                    if (subscribers.size || subscribersV2.size) {
                        console.log(`[RTDWC]Re-subscribing to previously subscribed dataset | timestamp=${new Date()}, UTC=${new Date().toUTCString()}`);
                        //Calling the connectionStatusCallback of all datasets after re initializing the socket
                        for (const key of Array.from(datasets.keys())) {
                            datasets.get(key)?.connectionStatusCallback(true);
                        }
                    }
                    //Resubscribing to the datasets after reconnection
                    for (const key of Array.from(subscribers.keys())) {
                        this.subscribe(key, subscribers.get(key));
                    }
                    for (const [key, subscriber] of subscribersV2.entries()) {
                        this.subscribeV2(key, subscriber);
                    }
                    this.shouldReconnect = true;
                    this.startWelcomeTime = new Date().getTime();
                    this.keepAliveWorker.onmessage = (event) => {
                        if (event?.data?.type === "keepalive") {
                            console.log(
                            // eslint-disable-next-line max-len
                            `[RTDWC] Keepalive from Desktop every 4 sec | { keepalive: 'true' } :: WS status: ${this.socket?.readyState} | timestamp=${new Date()}, UTC=${new Date().toUTCString()}`);
                            this.socket?.send(JSON.stringify({ keepalive: "true" }));
                        }
                        if (event?.data?.type === "closeSocket") {
                            isSocketClosed = true;
                            this.socket?.close();
                            console.log(`WebSocket did not auto close within 16 secs | WebSocket connection closed forcefully | timestamp=${new Date()}, UTC=${new Date().toUTCString()}`);
                        }
                    };
                    this.keepAliveWorker.postMessage({
                        type: "start",
                        intervalDuration: 4000,
                        pingURL: CONF.pingURL,
                        onlineStatus: this.onlineStatus,
                        closeSocketTimeout: 16000,
                        isSocketClosed
                    });
                    if (CONF.notifsWelcomeFlag) {
                        //If FF is on, wait 7sec for welcome msg before timeout error
                        this.startWelcomeTime = new Date().getTime();
                        setTimeout(() => {
                            if (!this.isWelcomeReceived) {
                                console.error(
                                // eslint-disable-next-line max-len
                                `[RTDWC] WebSocket registration error | Welcome Message from notifs not received within expected time of ${CONF.welcomeTimeout} ms | timestamp=${new Date()}, UTC=${new Date().toUTCString()}`);
                                reject(new Error("Welcome Message from notifs timed out"));
                            }
                        }, CONF.welcomeTimeout);
                    }
                    else {
                        setTimeout(() => {
                            console.info(`[RTDWC] Resolving notifs registration with a delay of ${NOTIFS_RESOLVE_DELAY} millisecs | timestamp=${new Date()}, UTC=${new Date().toUTCString()}`);
                            resolve({});
                        }, NOTIFS_RESOLVE_DELAY); //Resolving socket connection establishment is delayed by 1.2 secs until  WELCOME message is fied by CORE-4207.
                    }
                };
                this.socket.onclose = () => {
                    isSocketClosed = true;
                    this.keepAliveWorker.postMessage({ type: "terminate" });
                    //Calling the connectionStatusCallback of all datasets after socket closed
                    for (const key of Array.from(datasets.keys())) {
                        datasets.get(key)?.connectionStatusCallback(false);
                    }
                    if (this.shouldReconnect) {
                        this.onSocketCloseSend();
                        this.checkOnlineStatus().then((online) => {
                            const issueReason = !online ? "network issue" : "missing keep alive from notif service";
                            console.error(
                            // eslint-disable-next-line max-len
                            `[RTDWC] [WebSocketStatus] | event=socketConnectionClosed | WebSocket connection closed due to ${issueReason} | timestamp=${new Date()}, UTC=${new Date().toUTCString()}`);
                        });
                    }
                };
                this.socket.onmessage = (event) => {
                    console.log(`[RTDWC] Keepalive from realtime feed | timestamp=${new Date()}, UTC=${new Date().toUTCString()}`);
                    const { data } = event;
                    if (data) {
                        // Special handling for Welcome message when feature flag is enabled
                        if (CONF.notifsWelcomeFlag) {
                            const parsedData = typeof data === "string" ? JSON.parse(data) : data;
                            if (parsedData?.type === "Welcome") {
                                this.isWelcomeReceived = true;
                                this.endWelcomeTime = new Date().getTime();
                                console.log(`[RTDWC] Welcome message received after ${this.endWelcomeTime - this.startWelcomeTime} milliseconds | timestamp=${new Date()}, UTC=${new Date().toUTCString()}`);
                                resolve({});
                            }
                        }
                        if (typeof data === "string") {
                            // Process all messages through the unified message processor
                            this.processMessage(data);
                        }
                        else {
                            console.warn(`[RTDWC] Unexpected data in message handler ${data} | timestamp=${new Date()}, UTC=${new Date().toUTCString()}`);
                        }
                    }
                };
                this.socket.onerror = function (error) {
                    console.error(`[RTDWC] [error] ${error} | timestamp=${new Date()}, UTC=${new Date().toUTCString()}`);
                    reject(error.message);
                };
            }
            else {
                reject("[RTDWC] error in socket connection");
            }
        });
    }
}
